var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChart1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.230469,
    y: 0.470703,
    width: 28,
    height: 28,
    rx: 3,
    fill: "#003149"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6_27659)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18.1622,
    height: 18.1622,
    transform: "translate(4.77148 5.76758)",
    fill: "#003149"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.31137 13.3379C8.47893 13.3379 7.79785 14.019 7.79785 14.8514C7.79785 15.6838 8.47893 16.3649 9.31137 16.3649C10.1438 16.3649 10.8249 15.6838 10.8249 14.8514C10.8249 14.019 10.1438 13.3379 9.31137 13.3379ZM18.3924 13.3379C17.56 13.3379 16.8789 14.019 16.8789 14.8514C16.8789 15.6838 17.56 16.3649 18.3924 16.3649C19.2249 16.3649 19.906 15.6838 19.906 14.8514C19.906 14.019 19.2249 13.3379 18.3924 13.3379ZM13.8519 13.3379C13.0195 13.3379 12.3384 14.019 12.3384 14.8514C12.3384 15.6838 13.0195 16.3649 13.8519 16.3649C14.6843 16.3649 15.3654 15.6838 15.3654 14.8514C15.3654 14.019 14.6843 13.3379 13.8519 13.3379Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6_27659"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18.1622,
    height: 18.1622,
    fill: "white",
    transform: "translate(4.77148 5.76758)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChart1);
export default __webpack_public_path__ + "static/media/chart1.990f199b7e2efdcc2d7b22b002de1ec4.svg";
export { ForwardRef as ReactComponent };